import { useAgentPermissions, type AgentPermissions } from './useAgentPermissions'
import { usePulseMemory } from '../PulseMemory/usePulseMemory'

const LABELS: Record<keyof AgentPermissions, { icon: string; label: string; desc: string }> = {
  readFiles:        { icon: '📖', label: 'Read Files',        desc: 'AI can read project files for context' },
  writeFiles:       { icon: '✏️', label: 'Write Files',       desc: 'AI can create and modify files' },
  runTerminal:      { icon: '⌨️', label: 'Run Terminal',      desc: 'AI can execute shell commands' },
  installPackages:  { icon: '📦', label: 'Install Packages',  desc: 'AI can install npm/pip packages' },
  browseWeb:        { icon: '🌐', label: 'Browse Web',        desc: 'AI can search and fetch web pages' },
  accessMemory:     { icon: '🧠', label: 'Access Memory',     desc: 'AI can read/write project memory' },
}

export function AgentPermissionsPanel() {
  const project = usePulseMemory(s => s.memory.project) || 'default'
  const perms = useAgentPermissions(s => s.get(project))
  const setPerm = useAgentPermissions(s => s.set)
  const reset = useAgentPermissions(s => s.reset)

  const s: React.CSSProperties = { padding: 20, height: '100%', overflow: 'auto', fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-1)' }
  const card: React.CSSProperties = { background: 'var(--bg-2)', border: '1px solid var(--border)', borderRadius: 8, padding: 14, marginBottom: 12 }

  return (
    <div style={s}>
      <h3 style={{ margin: '0 0 4px', fontSize: 14, color: 'var(--accent)' }}>🔐 Agent Permissions</h3>
      <p style={{ margin: '0 0 6px', color: 'var(--text-2)', fontSize: 11 }}>
        Control what the AI agent can do in this project.
      </p>
      <p style={{ margin: '0 0 16px', color: 'var(--text-2)', fontSize: 10, opacity: 0.7 }}>
        Project: <strong style={{ color: 'var(--text-1)' }}>{project}</strong>
      </p>

      <div style={card}>
        {(Object.keys(LABELS) as (keyof AgentPermissions)[]).map(key => (
          <label key={key} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid var(--border)', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={perms[key]}
              onChange={e => setPerm(project, key, e.target.checked)}
              style={{ width: 16, height: 16, accentColor: 'var(--accent)' }}
            />
            <span style={{ fontSize: 14 }}>{LABELS[key].icon}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: 11 }}>{LABELS[key].label}</div>
              <div style={{ fontSize: 10, color: 'var(--text-2)' }}>{LABELS[key].desc}</div>
            </div>
          </label>
        ))}
      </div>

      <button
        onClick={() => reset(project)}
        style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid var(--border)', background: 'var(--bg-3)', color: 'var(--text-1)', cursor: 'pointer', fontSize: 11, fontFamily: 'var(--font-mono)' }}
      >
        ↺ Reset to Defaults
      </button>
    </div>
  )
}
